import isEmpty from 'lodash/isEmpty'
import {
  getAddressList as getAddressAutosuggestApi,
  // getAddressSearch as getAddressSearchApi,
  // getAddressDetail as getAddressDetailApi,
  getPoiDetailV2 as getPoiDetailApi,
  getFacilityDetail as getFacilityDetailApi,
  getRecommendPoi
} from '@/api/search'
import { combiningStrings } from '@/tools/basic-methods'
import polyline from '@/tools/polyline'

/**
 * 获取或者保存历史搜索数据
 */
export function searchLocalStorageControl(type='get', data) {
  let list = localStorage.getItem('addressSearchList')
  list = list ? JSON.parse(list).filter(item => !!item) : []
  if (type === 'get') {
    return list
  }
  let newList = []
  list.forEach(item => {
    if (item.pointType === data.pointType) {
      if (
        (item.pointType === 'poi' && item.ident !== data.ident) ||
        (item.pointType === 'address' && item.id !== data.id) ||
        (item.pointType === 'facility' && item.facilityId !== data.facilityId)
      ) {
        newList.push(item)
      }
    } else {
      newList.push(item)
    }
  })
  newList.unshift(Object.assign({}, data, { isHistory: true }))
  if (newList.length > 10) newList = newList.slice(0, 10)
  localStorage.setItem('addressSearchList', JSON.stringify(newList))
}

const state = {
  namespaced: true,
  state: {
    searchResult: {}, // 搜索结果, 信息中会包含但不是必需有isMapChange, 目的是是否改动地图
    dispatchSearchResult: {}, // dispatch的表单搜索结果
    dispatchSearchValue: '', // dispatch的表单搜索内容
  },
  mutations: {
    SET_SEARCH_RESULT(state, result) {
      state.searchResult = result
    },
    SET_DISPATCH_SEARCH_RESULT(state, result) {
      state.dispatchSearchResult = result
    },
    SET_DISPATCH_SEARCH_VALUE(state, value) {
      state.dispatchSearchValue = value
    }
  },
  actions: {
    updateDispatchSearchValue({ commit }, value) {
      commit('SET_DISPATCH_SEARCH_VALUE', value)
    },
    /**
     * search el-autocomplete组件的fetch-suggestions函数
     *
     * @param {String} value 输入框内容
     * @param {String} searchValue 点击右侧搜索按钮时输入框内容
     * @param {Boolean} isShowHistoricalData 要不要展示历史搜索数据
     */
    querySearch({ dispatch } ,{ value, searchValue, isShowHistoricalData=false }) {
      let isSearch = false
      if (!value && !isShowHistoricalData) {
        return []
      } else if (!value && isShowHistoricalData) {
        return searchLocalStorageControl()
      } else if (value === searchValue) {
        isSearch = true
      }
      return dispatch('getSearchPoiAndAddress', { value, isSearch, source: 'loads' })
    },
    /**
     * 获取poi和address的搜索结果
     *
     * @param {String} value 搜索内容
     * @param {Boolean} isSearch 是否使用address的search接口
     * @returns {Array} 返回搜索到的结果
     */
    getSearchPoiAndAddress({ dispatch }, data) {
      return dispatch('search/getSearchPoiAndAddress', data, { root: true })
    },
    /**
     * 获取address搜索结果
     */
    getAddressSearch({ rootState }, { value }) {
      let api = getAddressAutosuggestApi
      let { latitude: lat, longitude: lon } = rootState.inUseLocation
      let params = { input: value, lat, lon }
      // if (isSearch) api = getAddressSearchApi
      return api(params).then(
        result => {
          try {
            let data = result.res.data.data.filter(item => item.category !== 'administrative-region').map(item => {
              item.value = item.title
              item.unifiedTitle = item.highlightedTitle || item.title
              item.pointType = item.isFacility ? 'facility' : 'address'
              item.latitude = item.position[0]
              item.longitude = item.position[1]
              item.facilityId = item.facilityId || null
              item.pointId = item.id
              return item
            })
            return data.slice(0, 5)
          } catch(error) {
            console.log(error,'125');
            return []
          }
        },
        () => {
          return []
        }
      )
    },
    /**
     * 获取poi搜索结果
     */
    getPoiSearch({ rootState }, { value }) {
      let location = rootState.inUseLocation
      let params = {
        input: value,
        lat: location.latitude,
        lng: location.longitude
      }
      return getRecommendPoi(params).then(
        result => {
          try {
            let data = result.res.data.data.map(item => {
              item.value = item.title
              item.unifiedTitle = item.title
              item.pointType = 'poi'
              item.pointId = item.ident
              return item
            })
            return data
          } catch(error) {
            return []
          }
        },
        () => {
          return []
        }
      )
    },
    /**
     * 保存用户选中的搜索结果
     */
     setSearchResult({ commit }, params) {
      let result = params.result
      if (!isEmpty(result)) {
        searchLocalStorageControl('set', result)
      }
      if (params.source === 'map') {
        commit('SET_SEARCH_RESULT', result)
      } else {
        commit('SET_DISPATCH_SEARCH_RESULT', result)
      }
    },
    /**
     * 获取address详情
     *
     * @param {*} context
     * @param {*} info address基本信息
     * @returns
     */
    // getAddressDetail(context, info) {
    //   let params = {
    //     context: info.context,
    //     id: info.id
    //   }
    //   return getAddressDetailApi(params).then(
    //     result => {
    //       try {
    //         let data = result.res.data
    //         let bbox = data.bbox
    //         let category = data.category
    //         let title = data.name
    //         let location = data.location
    //         let position  = location.position
    //         let latitude = position[0]
    //         let longitude = position[1]
    //         let address = location.address
    //         let postalCode = address.postalCode
    //         let city = address.city
    //         let country = address.country
    //         let countryCode = address.countryCode
    //         let county = address.county
    //         let state = address.state
    //         let stateCode = address.stateCode
    //         let locationInfo = combiningStrings([city, stateCode, postalCode, countryCode])
    //         let resultInfo = {
    //           bbox, category, latitude, longitude, postalCode, city, country, title, 
    //           countryCode, county, state, stateCode, locationInfo,
    //           pointType: 'address', pointId: info.id,
    //           info: data
    //         }
    //         return resultInfo
    //       } catch (error) {
    //         console.log(error)
    //         return null
    //       }
    //     },
    //     (error) => {
    //       console.log(error)
    //       return null
    //     }
    //   )
    // },
    // 获取poi详情
    getPoiDetail(context, poiId) {
      return getPoiDetailApi(poiId).then(({ res }) => {
        try {
          let data = res.data.data
          let address = data.address
          let city = data.city
          let state = data.state
          let country = data.country
          let detailedAddress = combiningStrings([address, city, state, country])
          return Object.assign(data, { pointType: 'poi', pointId: data.ident, detailedAddress })
        } catch {
          return null
        }
      }).catch(() => {
        return null
      })
    },
    // 获取facility详情
    getFacilityDetail({ dispatch }, info) {
      let reviewParams = {
        limitReviews: 3,
        sort: '',
        page: 1,
        id: info.facilityId
      }
      let restaurantParams = {
        limitRest: 2,
        latitude: info.latitude,
        longitude: info.longitude
      }
      return Promise.all([
        getFacilityDetailApi(info.facilityId),
        dispatch('poiDetail/getFacilityReview', reviewParams, { root: true }),
        dispatch('poiDetail/getPointRestaurant', restaurantParams, { root: true })
      ]).then(result => {
        let detail = result[0].res.data.data
        let extensionInfo = detail.extensionInfo
        extensionInfo.fence = polyline.decodePolyline(extensionInfo.fence)
        extensionInfo.in = polyline.decodePolyline(extensionInfo.in)
        extensionInfo.inAccessRoad = polyline.decodePolyline(extensionInfo.inAccessRoad)
        extensionInfo.out = polyline.decodePolyline(extensionInfo.out)
        extensionInfo.outAccessRoad = polyline.decodePolyline(extensionInfo.outAccessRoad)
        detail.bbox = extensionInfo.bbox || []
        detail.latitude = detail.lat
        detail.longitude = detail.lng
        detail.latLng = detail.lat.toFixed(6) + ', ' + detail.lng.toFixed(6)
        detail.pointId = info.facilityId
        detail.reviewDetail = result[1]
        detail.restaurantDetail = result[2]
        return Promise.resolve(detail)
      }).catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
  }
}

export default state